var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var symboll = window.shop_symbol;
if (document.querySelector('[name="country_code"]') != null) {
  symboll =
    document.querySelector('[name="country_code"]').getAttribute("symbol") +
    "{{amount}}";
}
if (document.querySelector(".template--cart")) {
  var currentItemCount = Array.from(
    document
      .querySelector(".template--cart")
      .querySelectorAll('[name="updates[]"]')
  ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
} else {
  var currentItemCount = Array.from(
    document.querySelector(".cart-drawer").querySelectorAll('[name="quantity"]')
  ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
}
Shopify.money_format = symboll;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
var languageRoot = Shopify.routes.root;
var languageRootRemovedLastSlash = languageRoot.slice(
  0,
  languageRoot.length - 1
);
const cartItem = `<div data-product="%VARIANT_ID%" data-gift-product="%giftProduct%" class="columns is-multiline is-mobile is-marginless cart-drawer__products item-%PRODUCT_ID% shopItem">
      <div class="column is-4-desktop is-4-tablet is-3-mobile productImage">
          <a href="${languageRootRemovedLastSlash}/products/%HANDLE%" aria-label="Product link">%PRODUCT_IMAGE%</a>
      </div>
      <div class="column is-8-desktop is-8-tablet is-8-mobile">
        <div class="cart__drawer--title">
          <a href="${languageRootRemovedLastSlash}/products/%HANDLE%" aria-label="Product Title" tabindex="0"
          class="margin-b-10 margin-b-10 product-title" tabindex="0">%PRODUCT_TITLE%</a>
          <div class="product-option">
            <span class="option-label">%OPTION_LABEL_1%</span>
            <p class="select__variant">%SELECTED_VARIANT_1%</p>
          </div>
          <div class="product-option">
            <span class="option-label">%OPTION_LABEL_2%</span>
            <p class="select__variant">%SELECTED_VARIANT_2%</p>
          </div>
          <div class="product-option">
            <span class="option-label">%OPTION_LABEL_3%</span>
            <p class="select__variant">%SELECTED_VARIANT_3%</p>
          </div>
          <p class="selling-plan body--small mt-1"></p>
          <p class="product-price %PRODUCT_STATE%">
          <span class="price-item price-item--sale ">%FINAL_PRICE%</span> 
          <span class="price-item price-item--regular money" style="display:none">%COMPARE_PRICE%</span>
          </p>
          <div class="unit_price" unit_price>%UNIT_PRICE%</div>
          <ul class="discounts-item list-unstyled" role="list" aria-label="discounts">
          %DISCOUNTS%
          </ul>
        </div>
          <div class="form-field form-options js-required">

          <div class="product-form__input product-form__quantity">
           <div class="quantity__main quantity__main-cart">
              <button class="quantity_box quantity__decrease" name="minus">
                <span>-</span>
              </button>
              <div class="quantity_box quantity_num">
                <input id="quantity" name="quantity" type="number" min="1" value="%ITEM-QUANTITY%" line-item-id="%PRODUCT_ID%" variant_id="%PRODUCT_ID%">
              </div>
              <button class="quantity_box quantity__increase" name="plus">
                <span>+</span>
              </button>
            </div>
            <div class="cart-item__error" id="Line-item-error-%PRODUCT_ID%" role="alert">
            <small class="cart-item__error-text"></small>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
              <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
              <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
              <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
              <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
            </svg>
          </div>
          </div>
          </div>
          <a href="javascript:void(0)" onClick="removeItem(%VARIANT_ID%);" class="is-marginless removeItem">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M2 6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6ZM4 8V18H16V8H4ZM7 10H9V16H7V10ZM11 10H13V16H11V10ZM5 3V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V3H20V5H0V3H5ZM7 2V3H13V2H7Z" fill="#DB5858"/>
            </svg>
          </a>
      </div>
  </div>`;
var isOpen = false;

var addedSuggested = 0;
var timer;

document.addEventListener("click", (event) => {
  var clickedAtcButton =
    event.target.closest(".add-to-cart-btn") ||
    event.target.closest(".product-form__submit");
  if (!clickedAtcButton) return; //do nothing

  if (window.settings.cartType === "cart-drawer") {
    event.preventDefault();

    var self = clickedAtcButton;

    var product_id = self.getAttribute("product_id");
    var metaf = self.getAttribute("metaf");

    var data = new FormData(self.closest("form"));

    addProductToCart(product_id, metaf, product_id, data);
  }
});

const cartDrawer = document.querySelector(".cart-drawer");

// CLICK
cartDrawer.addEventListener("click", (event) => {
  var clickedQuantityButton = event.target.closest(".quantity__main button");
  if (!clickedQuantityButton) return; //do nothing

  event.preventDefault();
  var quantityWrapper = event.target.closest(".quantity__main");
  var quantityInput = quantityWrapper.querySelector('input[type="number"]');
  var quantityButtonMinus = quantityWrapper.querySelector(
    'button[name="minus"]'
  );
  var quantityButtonPlus = quantityWrapper.querySelector('button[name="plus"]');

  var currentValue = quantityInput.value;

  if (clickedQuantityButton.getAttribute("name") == "plus") {
    currentValue = parseFloat(currentValue) + 1;
  } else if (clickedQuantityButton.getAttribute("name") == "minus") {
    if (currentValue > 0) {
      currentValue = parseFloat(currentValue) - 1;
    }
  }

  document
    .querySelectorAll(".quantity_box")
    .forEach((el) => el.setAttribute("disabled", "disabled"));
  setTimeout(function () {
    testQty(
      quantityWrapper
        .querySelector('[name="quantity"]')
        .getAttribute("variant_id"),
      currentValue
    );
  }, 50);
});
// CLICK

// CHANGE
cartDrawer.addEventListener("change", (event) => {
  const changedQuantityElement = event.target.closest('[name="quantity"]');
  if (!changedQuantityElement) return; //do nothing

  event.preventDefault();
  var currentValue = changedQuantityElement.value;
  setTimeout(function () {
    testQty(changedQuantityElement.getAttribute("variant_id"), currentValue);
  }, 50);
});
// CHANGE

function addProductToCart(formID, metafields, productID, target) {
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);

  fetch(window.routes.cart_add_url + ".js", {
    body: target,
    headers: {
      "X-Requested-With": "xmlhttprequest",
    },
    method: "POST",
  })
    .then(function (response) {
      return response.json();
    })
    .then(function addProductToCartSuccess(response) {
      if (response.status) {
        handleErrorMessage(response.description);
        return;
      } else {
        let errorMessageWrapper = document.querySelector(
          ".product-form__error-message-wrapper"
        );
        let this_errorMessage = errorMessageWrapper.querySelector(
          ".product-form__error-message"
        );
        errorMessageWrapper.toggleAttribute("hidden", true);
        this_errorMessage.textContent = "";
      }
      /* gift wrap code */
      var productOrQuickViewWrapper =
        document.querySelector(".quick-view_grid") ||
        document.querySelector(".product__detail");

      if (
        productOrQuickViewWrapper.querySelector(".product__wrapping") &&
        productOrQuickViewWrapper.querySelector("#add_gift_wrapping").checked ==
          true
      ) {
        var gift_wrapping_container =
          productOrQuickViewWrapper.querySelector(".product__wrapping");
        var gift_wrapping_id = gift_wrapping_container.dataset.giftId;
        var message = gift_wrapping_container.querySelector("textarea").value;
        var product = gift_wrapping_container.dataset.giftProduct;
        var gift = {
          id: gift_wrapping_id,
          quantity: 1,
          properties: {
            _gift_wrapping_message: message,
            _gift_wrapping_product: product,
          },
        };
        var data = {
          items: [],
        };
        data["items"].push(gift);

        fetch(window.routes.cart_add_url + ".js", {
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "POST",
        })
          .then(function (response) {
            return response.json();
          })
          .then(function addProductToCartSuccess(response) {
            var this_data = response;
            addToCartOk(this_data);
          });
      } else {
        var data = response;
        addToCartOk(data);
      }
    })
    .catch(function errorHandler(error) {
      console.warn(
        "Something went wrong with store.js addProductToCart.",
        error
      );
    });
  if (metafields != "") {
    window.localStorage.setItem("metafields-" + productID, metafields);
  }
  return false;
}

function handleErrorMessage(errorMessage = false) {
  let errorMessageWrappers = document.querySelectorAll(
    ".product-form__error-message-wrapper"
  );
  errorMessageWrappers.forEach((errorMessageWrapper) => {
    let this_errorMessage = errorMessageWrapper.querySelector(
      ".product-form__error-message"
    );
    errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (typeof errorMessage === "object") {
      let entries = Object.entries(errorMessage);
      let data = entries.map(([key, val] = entry) => {
        return `${val}`;
      });
      this_errorMessage.textContent = data;
    } else {
      this_errorMessage.textContent = errorMessage;
    }
  });
}

function testQty(itemID, value) {
  if (value != "Dummy") {
    changeItem(itemID, value);
  }
}

function fetchCartDrawer(line) {
  var old_quantity = 0,
    new_quantity = 0;
  if (line) {
    var line_container = document.querySelector(
      `.cart-drawer [data-product="${line}"]`
    );
    if (line_container) {
      old_quantity =
        line_container.querySelector('[name="quantity"]').value * 1;
    }
  }
  fetch(window.routes.cart_url + ".js")
    .then((response) => response.json())
    .then((response) => {
      var cart = response;
      onCartUpdate(cart);
      renderCartDrawer(cart, line, old_quantity);
    });
}

function changeItem(line, quantity, callback) {
  if (isNotLoading()) {
    startLoading();
  }
  // Check if this product has gift wrapping
  if (!!document.querySelector(`.cart [data-gift-product="${line}"]`)) {
    var new_id = document.querySelector(`.cart [data-gift-product="${line}"]`)
      .dataset.product;
    var data = {};
    data["id"] = line.toString();
    data["quantity"] = quantity;
  } else {
    var data = {};
    data["id"] = line.toString();
    data["quantity"] = quantity;
  }

  var original_quantity = fetch(window.routes.cart_change_url + ".js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      renderCart(cart, line);
    })
    .catch(function (error) {
      // Catch errors
      console.warn(error);
    });
}
function renderCart(cart, line) {
  if (document.body.classList.contains("template--cart")) {
    updateCartpage(line);
  }
  if (typeof callback === "function") {
    callback(cart);
  } else {
    onCartUpdate(cart);
    fetchCartDrawer(line);
  }
}
function updateCartpage(line) {
  enableLoading();
  var old_quantity = 0,
    new_quantity = 0;
  var line_container = document.querySelector(
    `.cart-page [data-product="${line}"]`
  );
  if (line_container) {
    old_quantity = line_container.querySelector('[name="quantity"]').value * 1;
  }
  fetch(window.routes.cart_url)
    .then((response) => {
      return response.text();
    })
    .then((res) => {
      var new_html = new DOMParser().parseFromString(res, "text/html");
      // Check if cart is empty
      if (new_html.querySelector(".cart__warnings")) {
        document.querySelector(".cart-page").innerHTML =
          new_html.querySelector(".cart-page").innerHTML;
        document.querySelector(".cart-count-bubble").style.display = "none";
        disableLoading();
        return;
      }
      // update error message
      var line_container = new_html.querySelector(`[data-product="${line}"]`);
      if (line_container) {
        new_quantity =
          line_container.querySelector('[name="quantity"]').value * 1;
      }
      if (
        new_html.querySelector(
          `.cart-page #Line-item-error-${line} .cart-item__error-text`
        )
      ) {
        var textwrapper = new_html.querySelector(
          `.cart-page #Line-item-error-${line} .cart-item__error-text`
        );
        if (old_quantity > new_quantity) {
          const text = window.cartStrings.quantityError.replace(
            "[quantity]",
            new_quantity
          );
          textwrapper.textContent = text;
        } else {
          textwrapper.textContent = "";
        }
      }

      // Update cart page
      document.querySelector(".cart-page .cart-content_inner").innerHTML =
        new_html.querySelector(".cart-page .cart-content_inner").innerHTML;
      disableLoading();
    });
}
function enableLoading() {
  document.querySelector(".loading-overlay").style.display = "block";
}
function disableLoading() {
  document.querySelector(".loading-overlay").style.display = "none";
}
function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}

function removeItem(itemID) {
  if (!!document.querySelector(".item-" + itemID)) {
    changeItem(itemID, 0);
    document.querySelector(".item-" + itemID).remove();
  }
}

function onCartUpdate(cart) {
  // Do nothing, logic handled before render
}

function addToCartOk(product) {
  if (isNotLoading()) {
    startLoading();
  }
  if (!isCartOpen()) {
    openCart();
  }
  setTimeout(() => fetchCartDrawer(), 300);
}

function addToCartFail() {
  console.warn("Error adding to cart: -------------------");
}

function renderCartDrawer(cart, line, old_quantity) {
  var container = document.querySelector(".cart-drawer");

  const cartItemHolder = document.querySelector(".cart-drawer__cart");

  if (cart.items.length != 0) {
    document.querySelector(".cartEmptyHolder").classList.add("is-hidden");
    document.querySelector(".cartItemHolder").classList.remove("is-hidden");
  } else {
    document.querySelector(".cartEmptyHolder").classList.remove("is-hidden");
    document.querySelector(".cartItemHolder").classList.add("is-hidden");
  }

  if (!!document.querySelector("#product1Variant")) {
    document
      .getElementById("product1Variant")
      .addEventListener("change", function (event) {
        document.getElementById("product1_price").innerText =
          product1_price[this.value];
        document.getElementById("product1_compare").innerText =
          product1_compare[this.value];
      });
  }

  if (document.querySelector(".header-cart-count")) {
    if (cart.item_count > 0) {
      document
        .querySelector(".header-cart-count")
        .closest(".cart-count-bubble").style.display = "flex";
    } else {
      document
        .querySelector(".header-cart-count")
        .closest(".cart-count-bubble").style.display = "none";
    }
    document.querySelector(".header-cart-count").innerText = cart.item_count;
  }

  if (!!document.querySelector(".shopItem")) {
    document.querySelectorAll(".shopItem").forEach(function (shopItem) {
      shopItem.remove();
    });
  }

  var cartTotal = 0;

  if (!!document.querySelector("#product1Form")) {
    document.querySelector("#product1Form").style.display = "block";
  }
  if (!!document.querySelector("#product2Form")) {
    document.querySelector("#product2Form").style.display = "block";
  }
  addedSuggested = 0;

  cart.items.forEach(function (item, index) {
    var productHandle = item.url.split("?")[0];
    var compare_price = "";

    compare_price = Shopify.formatMoney(item.original_price);

    cartTotal += item.quantity;
    var subtotal = "" + Shopify.formatMoney(cart.items_subtotal_price);
    var original_subtotal = "" + Shopify.formatMoney(cart.original_total_price);
    var discounted_cal =
      parseFloat(cart.original_total_price) -
      parseFloat(cart.items_subtotal_price);
    var discounted_amount = "" + Shopify.formatMoney(discounted_cal);
    var cost = "" + Shopify.formatMoney(item.discounted_price);
    var cost2 = cost;
    if (item.unit_price != undefined) {
      var unit_price = Shopify.formatMoney(item.unit_price);
      var referal_unit = "";
      if (item.unit_price_measurement.reference_value != 1) {
        referal_unit =
          item.unit_price_measurement.reference_value +
          item.unit_price_measurement.reference_unit;
      } else {
        referal_unit = item.unit_price_measurement.reference_unit;
      }
      var unit_price_referal = unit_price + " / " + referal_unit;
    } else {
      unit_price_referal = "";
    }
    var _imgr = "";
    if (item.image != null) {
      var img_tag_src = item.image
        .replace(".png", "_170x170_crop_center.png")
        .replace(".jpg", "_170x170_crop_center.jpg");
      _imgr = '<img src="' + img_tag_src + '" loading="lazy" alt="product" />';
    } else {
      _imgr =
        '<svg xmlns="http://www.w3.org/2000/svg" class="has-background-light" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>';
    }

    var discount_html = "";
    if (item.line_level_discount_allocations) {
      item.line_level_discount_allocations.forEach((discount_allocation) => {
        if (discount_allocation) {
          discount_html +=
            `<li class="title_discount-subtotal">
          ` +
            `<svg class="icon icon-discount" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 96 96"  xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" id="Discount" d="m56.865 91.005c-2.029 0-3.842-1.483-5.603-2.923-1.076-.881-2.551-2.087-3.263-2.087-.711 0-2.186 1.206-3.262 2.087-1.929 1.577-4.117 3.37-6.526 2.818-2.486-.565-3.703-3.179-4.777-5.484-.536-1.153-1.348-2.896-1.925-3.175-.612-.299-2.512.162-3.769.464-2.447.589-5.219 1.253-7.179-.31-1.967-1.571-1.932-4.432-1.899-6.955.016-1.287.04-3.231-.374-3.751-.409-.512-2.302-.917-3.555-1.185-2.478-.53-5.284-1.131-6.384-3.411-1.084-2.245.181-4.791 1.295-7.037.579-1.164 1.453-2.925 1.3-3.6-.138-.605-1.644-1.774-2.64-2.548-2.017-1.564-4.304-3.34-4.304-5.908s2.287-4.343 4.305-5.909c.996-.773 2.502-1.942 2.64-2.548.153-.675-.721-2.436-1.299-3.601-1.115-2.246-2.379-4.791-1.294-7.038 1.1-2.279 3.906-2.88 6.383-3.41 1.253-.268 3.146-.673 3.554-1.184.416-.521.392-2.466.376-3.753-.032-2.523-.067-5.383 1.899-6.954 1.959-1.564 4.733-.898 7.179-.31 1.259.302 3.157.759 3.768.465.578-.279 1.389-2.021 1.926-3.175 1.073-2.306 2.289-4.919 4.775-5.484 2.406-.546 4.598 1.24 6.526 2.818 1.077.881 2.552 2.087 3.263 2.087s2.186-1.206 3.262-2.086c1.93-1.579 4.117-3.369 6.527-2.819 2.485.565 3.702 3.179 4.776 5.485.537 1.153 1.348 2.896 1.926 3.175.613.295 2.51-.163 3.767-.465 2.447-.588 5.22-1.254 7.18.31 1.967 1.571 1.932 4.431 1.899 6.955-.016 1.287-.04 3.232.374 3.751.409.511 2.302.917 3.555 1.185 2.478.53 5.284 1.13 6.384 3.41 1.084 2.246-.181 4.792-1.295 7.038-.579 1.165-1.453 2.925-1.3 3.6.138.606 1.644 1.775 2.64 2.548 2.017 1.566 4.304 3.341 4.304 5.909s-2.287 4.343-4.305 5.909c-.996.773-2.502 1.941-2.64 2.549-.153.675.721 2.435 1.299 3.6 1.115 2.246 2.379 4.791 1.294 7.038-1.1 2.279-3.906 2.88-6.383 3.409-1.253.269-3.146.674-3.555 1.185-.415.521-.391 2.466-.375 3.753.032 2.522.067 5.382-1.899 6.953-1.959 1.564-4.733.897-7.179.31-1.259-.302-3.157-.761-3.768-.464-.578.278-1.389 2.021-1.926 3.174-1.073 2.307-2.289 4.92-4.775 5.485-.312.071-.62.104-.923.104zm-25.975-12.855c.829 0 1.624.134 2.357.487 1.863.898 2.855 3.029 3.814 5.09.475 1.02 1.463 3.142 2.036 3.272.533.094 2.273-1.333 3.107-2.015 1.798-1.47 3.656-2.99 5.795-2.99s3.998 1.521 5.795 2.99c.834.682 2.522 2.081 3.109 2.015.571-.131 1.56-2.252 2.034-3.272.958-2.061 1.95-4.19 3.814-5.09 1.896-.915 4.204-.358 6.439.179 1.075.258 3.316.797 3.748.453.439-.35.41-2.665.396-3.777-.029-2.292-.059-4.661 1.249-6.299 1.3-1.628 3.609-2.122 5.843-2.6 1.094-.234 3.369-.721 3.618-1.236.232-.483-.786-2.535-1.275-3.521-1.025-2.065-2.086-4.201-1.616-6.265.455-2.002 2.302-3.436 4.087-4.822.966-.748 2.76-2.14 2.76-2.749s-1.794-2.001-2.758-2.75c-1.786-1.386-3.633-2.819-4.088-4.822-.469-2.064.592-4.2 1.617-6.265.489-.986 1.508-3.037 1.275-3.521-.249-.516-2.524-1.002-3.617-1.236-2.234-.478-4.544-.972-5.844-2.599-1.307-1.637-1.277-4.007-1.248-6.298.014-1.112.043-3.428-.396-3.778-.43-.344-2.672.195-3.749.453-2.234.537-4.542 1.093-6.439.178-1.863-.899-2.855-3.029-3.814-5.089-.475-1.02-1.462-3.142-2.036-3.272-.55-.095-2.274 1.333-3.108 2.014-1.797 1.471-3.655 2.991-5.794 2.991s-3.997-1.521-5.795-2.991c-.834-.682-2.574-2.103-3.109-2.015-.572.13-1.561 2.252-2.035 3.272-.959 2.06-1.95 4.19-3.813 5.089-1.896.914-4.204.36-6.44-.178-1.075-.259-3.318-.797-3.748-.454-.439.351-.41 2.666-.396 3.778.029 2.292.059 4.662-1.249 6.298-1.3 1.628-3.609 2.122-5.843 2.6-1.094.234-3.369.721-3.618 1.236-.232.483.786 2.535 1.275 3.521 1.025 2.065 2.086 4.201 1.616 6.265-.455 2.002-2.302 3.436-4.087 4.822-.965.75-2.759 2.142-2.759 2.751s1.794 2.002 2.758 2.75c1.786 1.386 3.633 2.818 4.088 4.821.469 2.064-.592 4.199-1.617 6.265-.489.986-1.508 3.037-1.275 3.521.249.517 2.524 1.003 3.618 1.237 2.233.478 4.543.972 5.843 2.6 1.307 1.637 1.277 4.006 1.248 6.298-.014 1.112-.043 3.428.396 3.778.43.339 2.672-.195 3.749-.454 1.369-.33 2.768-.666 4.082-.666zm4.524-14.736 28-28c.781-.781.781-2.047 0-2.828s-2.047-.781-2.828 0l-28 28c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586zm2.586-18.414c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zm0-10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm20 30c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zm0-10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z" fill="currentColor" class=""></path></g></svg>` +
            discount_allocation.discount_application.title +
            "(-" +
            Shopify.formatMoney(discount_allocation.amount) +
            ")" +
            `</li>`;
        }
      });
    }

    var cartItem2 = replaceAll(cartItem, "%PRODUCT_TITLE%", item.product_title);
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_IMAGE%", _imgr);
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_STATE%", "price--on-regular");
    cartItem2 = replaceAll(cartItem2, "%FINAL_PRICE%", cost2);
    cartItem2 = replaceAll(cartItem2, "%UNIT_PRICE%", unit_price_referal);
    cartItem2 = replaceAll(cartItem2, "%DISCOUNTS%", discount_html);

    if (compare_price > 0) {
      cartItem2 = replaceAll(
        cartItem2,
        "%COMPARE_PRICE%",
        Shopify.formatMoney(compare_price)
      );
    }
    cartItem2 = replaceAll(cartItem2, "%ITEM-QUANTITY%", item.quantity);

    if (item.variant_options[0] != "Default Title") {
      if (item.options_with_values[0]?.value) {
        cartItem2 = replaceAll(
          cartItem2,
          "%SELECTED_VARIANT_1%",
          item.options_with_values[0]?.value
        );
      } else {
        cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_1%", " ");
      }
      if (item.options_with_values[1]?.value) {
        cartItem2 = replaceAll(
          cartItem2,
          "%SELECTED_VARIANT_2%",
          item.options_with_values[1]?.value
        );
      } else {
        cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_2%", " ");
      }
      if (item.options_with_values[2]?.value) {
        cartItem2 = replaceAll(
          cartItem2,
          "%SELECTED_VARIANT_3%",
          item.options_with_values[2]?.value
        );
      } else {
        cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_3%", " ");
      }
      if (item.options_with_values[0]?.name) {
        cartItem2 = replaceAll(
          cartItem2,
          "%OPTION_LABEL_1%",
          item.options_with_values[0]?.name + ":"
        );
      } else {
        cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_1%", " ");
      }
      if (item.options_with_values[1]?.name) {
        cartItem2 = replaceAll(
          cartItem2,
          "%OPTION_LABEL_2%",
          item.options_with_values[1]?.name + ":"
        );
      } else {
        cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_2%", " ");
      }
      if (item.options_with_values[2]?.name) {
        cartItem2 = replaceAll(
          cartItem2,
          "%OPTION_LABEL_3%",
          item.options_with_values[2]?.name + ":"
        );
      } else {
        cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_3%", " ");
      }
    } else {
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_1%", " ");
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_2%", " ");
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_3%", " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_1%", " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_2%", " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_3%", " ");
    }

    cartItem2 = replaceAll(cartItem2, "%PRODUCT_ID%", item.id);
    cartItem2 = replaceAll(cartItem2, "%VARIANT_ID%", item.variant_id);
    cartItem2 = replaceAll(cartItem2, "%HANDLE%", item.handle);
    if (item.properties && item.properties._gift_wrapping_product) {
      cartItem2 = replaceAll(
        cartItem2,
        "%giftProduct%",
        item.properties._gift_wrapping_product
      );
    } else {
      cartItem2 = replaceAll(cartItem2, "%giftProduct%", "");
    }

    // cartItemHolder.prepend(cartItem2);
    var cartParser = new DOMParser();
    var cartDocument = cartParser.parseFromString(cartItem2, "text/html");
    var cartHtml = cartDocument.querySelector(".cart-drawer__products");
    cartItemHolder.prepend(cartHtml);

    var itemElement = document.querySelector(`.item-${item.id}`);

    if (item.selling_plan_allocation) {
      itemElement.querySelector(`p.selling-plan`).innerText =
        item.selling_plan_allocation.selling_plan.name;
    }
    if (!!document.querySelector(".items_subtotal")) {
      document.querySelector(".items_subtotal").innerText = subtotal;
    }

    // DISCOUNT
    var cart_discount_html = "";
    if (cart.cart_level_discount_applications) {
      cart.cart_level_discount_applications.forEach((discount_allocation) => {
        if (discount_allocation) {
          cart_discount_html +=
            `<li class="title_discount-subtotal">
              ` +
            `<svg class="icon icon-discount" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 96 96"  xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" id="Discount" d="m56.865 91.005c-2.029 0-3.842-1.483-5.603-2.923-1.076-.881-2.551-2.087-3.263-2.087-.711 0-2.186 1.206-3.262 2.087-1.929 1.577-4.117 3.37-6.526 2.818-2.486-.565-3.703-3.179-4.777-5.484-.536-1.153-1.348-2.896-1.925-3.175-.612-.299-2.512.162-3.769.464-2.447.589-5.219 1.253-7.179-.31-1.967-1.571-1.932-4.432-1.899-6.955.016-1.287.04-3.231-.374-3.751-.409-.512-2.302-.917-3.555-1.185-2.478-.53-5.284-1.131-6.384-3.411-1.084-2.245.181-4.791 1.295-7.037.579-1.164 1.453-2.925 1.3-3.6-.138-.605-1.644-1.774-2.64-2.548-2.017-1.564-4.304-3.34-4.304-5.908s2.287-4.343 4.305-5.909c.996-.773 2.502-1.942 2.64-2.548.153-.675-.721-2.436-1.299-3.601-1.115-2.246-2.379-4.791-1.294-7.038 1.1-2.279 3.906-2.88 6.383-3.41 1.253-.268 3.146-.673 3.554-1.184.416-.521.392-2.466.376-3.753-.032-2.523-.067-5.383 1.899-6.954 1.959-1.564 4.733-.898 7.179-.31 1.259.302 3.157.759 3.768.465.578-.279 1.389-2.021 1.926-3.175 1.073-2.306 2.289-4.919 4.775-5.484 2.406-.546 4.598 1.24 6.526 2.818 1.077.881 2.552 2.087 3.263 2.087s2.186-1.206 3.262-2.086c1.93-1.579 4.117-3.369 6.527-2.819 2.485.565 3.702 3.179 4.776 5.485.537 1.153 1.348 2.896 1.926 3.175.613.295 2.51-.163 3.767-.465 2.447-.588 5.22-1.254 7.18.31 1.967 1.571 1.932 4.431 1.899 6.955-.016 1.287-.04 3.232.374 3.751.409.511 2.302.917 3.555 1.185 2.478.53 5.284 1.13 6.384 3.41 1.084 2.246-.181 4.792-1.295 7.038-.579 1.165-1.453 2.925-1.3 3.6.138.606 1.644 1.775 2.64 2.548 2.017 1.566 4.304 3.341 4.304 5.909s-2.287 4.343-4.305 5.909c-.996.773-2.502 1.941-2.64 2.549-.153.675.721 2.435 1.299 3.6 1.115 2.246 2.379 4.791 1.294 7.038-1.1 2.279-3.906 2.88-6.383 3.409-1.253.269-3.146.674-3.555 1.185-.415.521-.391 2.466-.375 3.753.032 2.522.067 5.382-1.899 6.953-1.959 1.564-4.733.897-7.179.31-1.259-.302-3.157-.761-3.768-.464-.578.278-1.389 2.021-1.926 3.174-1.073 2.307-2.289 4.92-4.775 5.485-.312.071-.62.104-.923.104zm-25.975-12.855c.829 0 1.624.134 2.357.487 1.863.898 2.855 3.029 3.814 5.09.475 1.02 1.463 3.142 2.036 3.272.533.094 2.273-1.333 3.107-2.015 1.798-1.47 3.656-2.99 5.795-2.99s3.998 1.521 5.795 2.99c.834.682 2.522 2.081 3.109 2.015.571-.131 1.56-2.252 2.034-3.272.958-2.061 1.95-4.19 3.814-5.09 1.896-.915 4.204-.358 6.439.179 1.075.258 3.316.797 3.748.453.439-.35.41-2.665.396-3.777-.029-2.292-.059-4.661 1.249-6.299 1.3-1.628 3.609-2.122 5.843-2.6 1.094-.234 3.369-.721 3.618-1.236.232-.483-.786-2.535-1.275-3.521-1.025-2.065-2.086-4.201-1.616-6.265.455-2.002 2.302-3.436 4.087-4.822.966-.748 2.76-2.14 2.76-2.749s-1.794-2.001-2.758-2.75c-1.786-1.386-3.633-2.819-4.088-4.822-.469-2.064.592-4.2 1.617-6.265.489-.986 1.508-3.037 1.275-3.521-.249-.516-2.524-1.002-3.617-1.236-2.234-.478-4.544-.972-5.844-2.599-1.307-1.637-1.277-4.007-1.248-6.298.014-1.112.043-3.428-.396-3.778-.43-.344-2.672.195-3.749.453-2.234.537-4.542 1.093-6.439.178-1.863-.899-2.855-3.029-3.814-5.089-.475-1.02-1.462-3.142-2.036-3.272-.55-.095-2.274 1.333-3.108 2.014-1.797 1.471-3.655 2.991-5.794 2.991s-3.997-1.521-5.795-2.991c-.834-.682-2.574-2.103-3.109-2.015-.572.13-1.561 2.252-2.035 3.272-.959 2.06-1.95 4.19-3.813 5.089-1.896.914-4.204.36-6.44-.178-1.075-.259-3.318-.797-3.748-.454-.439.351-.41 2.666-.396 3.778.029 2.292.059 4.662-1.249 6.298-1.3 1.628-3.609 2.122-5.843 2.6-1.094.234-3.369.721-3.618 1.236-.232.483.786 2.535 1.275 3.521 1.025 2.065 2.086 4.201 1.616 6.265-.455 2.002-2.302 3.436-4.087 4.822-.965.75-2.759 2.142-2.759 2.751s1.794 2.002 2.758 2.75c1.786 1.386 3.633 2.818 4.088 4.821.469 2.064-.592 4.199-1.617 6.265-.489.986-1.508 3.037-1.275 3.521.249.517 2.524 1.003 3.618 1.237 2.233.478 4.543.972 5.843 2.6 1.307 1.637 1.277 4.006 1.248 6.298-.014 1.112-.043 3.428.396 3.778.43.339 2.672-.195 3.749-.454 1.369-.33 2.768-.666 4.082-.666zm4.524-14.736 28-28c.781-.781.781-2.047 0-2.828s-2.047-.781-2.828 0l-28 28c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586zm2.586-18.414c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zm0-10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm20 30c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zm0-10c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z" fill="currentColor" class=""></path></g></svg>` +
            discount_allocation.title +
            "(-" +
            Shopify.formatMoney(discount_allocation.total_allocated_amount) +
            ")" +
            `</li>`;
        }
      });
    }
    if (
      document.querySelector(".cart-drawer .discounts-subtotal") &&
      document.querySelector(".cart-drawer .discounts-subtotal").innerHTML ===
        ""
    ) {
      document.querySelector(".cart-drawer .discounts-subtotal").innerHTML =
        cart_discount_html;
    }

    var symboll = window.shop_symbol;
    if (document.querySelector('[name="country_code"]') != null) {
      symboll =
        document.querySelector('[name="country_code"]').getAttribute("symbol") +
        "{{amount}}";
    }
    var vlue_zero = Shopify.formatMoney("0.00");

    if (
      !!document.querySelector(
        `#QTY-${item.id} option:nth-child(${Number(item.quantity) + 1})`
      )
    ) {
      document
        .querySelector(
          `#QTY-${item.id} option:nth-child(${Number(item.quantity) + 1})`
        )
        .setAttribute("selected", "selected");
    }

    // update error message
    if (
      document.querySelector(
        `.cart-drawer #Line-item-error-${line} .cart-item__error-text`
      )
    ) {
      if (item.id === line * 1) {
        var new_quantity = item.quantity;
        var textwrapper = document.querySelector(
          `.cart-drawer #Line-item-error-${line} .cart-item__error-text`
        );
        if (old_quantity > new_quantity) {
          const text = window.cartStrings.quantityError.replace(
            "[quantity]",
            new_quantity
          );
          textwrapper.textContent = text;
        } else {
          textwrapper.textContent = "";
        }
      }
    }
  });
  if (cart.item_count > 1) {
    itemTimer(cart);
  } else if (cart.item_count == 1) {
    itemTimer(cart);
  } else {
    if (!!document.querySelector(".items_subtotal")) {
      document.querySelector(".items_subtotal").innerText = "Empty";
    }
    itemTimer(cart);
  }
  var text = document.querySelector(".view_cart-btn").innerText;
  var new_text = text.replace(/\(.*?\)/g, "(" + cart.item_count + ")");
  document.querySelector(".view_cart-btn").innerText = new_text;

  stopLoading();
  document
    .querySelectorAll(".quantity_box")
    .forEach((el) => el.removeAttribute("disabled"));
}

function onTidioChatApiReady() {
  setTimeout(function () {
    if (!!document.querySelector("#tidio-chat-iframe")) {
      document.querySelector("#tidio-chat-iframe").style.zIndex = 699;
    }
  }, 500);
}
function DOMready(callback) {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

DOMready(function () {
  fetchCartDrawer();
});

function closeCart() {
  document.documentElement.style.overflowY = "scroll";
  isOpen = false;
  document.querySelector(".cart-flyout").classList.add("is-closing");
  document.querySelector(".cart-flyout").classList.remove("is-active");
  // document.querySelector('.cart-flyout').style.display = 'none';
  document.querySelector(".cartOverlay").style.display = "none";

  setTimeout(function () {
    document.querySelector(".cart-flyout").classList.remove("is-closing");
    document.querySelector(".cart-flyout").style.display = "none";
  }, 750);

  removeTrapFocus(document.getElementById("cart-icon-bubble"));
}

function openCart() {
  document.documentElement.style.overflowY = "hidden";
  isOpen = true;
  document.querySelector(".cart-flyout").style.display = "";
  document.querySelector(".cart-flyout").classList.remove("is-closing");
  document.querySelector(".cart-flyout").classList.add("is-active");
  let drawerCartElem = document.querySelector(".cart-drawer");

  trapFocus(
    drawerCartElem,
    document.querySelector(".cart-drawer__close > button")
  );

  drawerCartElem.addEventListener("keyup", function (event) {
    if (event.code == "Escape") {
      closeCart();
    }
  });

  setTimeout(
    () => (document.querySelector(".cartOverlay").style.display = "block"),
    50
  );
}
document
  .getElementById("cart-icon-bubble")
  .addEventListener("click", function (event) {
    if (window.settings.cartType !== "cart-drawer") {
      return;
    }
    event.preventDefault();
    if (!document.body.classList.contains("template--cart")) {
      toggleCart();
    }
  });

function toggleCart() {
  event.preventDefault();
  if (isCartOpen()) {
    closeCart();
    return false;
  } else {
    openCart();
    return false;
  }
}

function isCartOpen() {
  return isOpen;
}

function clickOverlay() {
  toggleCart();
}

function addSuggested(formID, metafields, itemID, productID) {
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  if (isNotLoading()) {
    startLoading();
  }
  if (!isCartOpen()) {
    openCart();
  }

  if (!!document.querySelector(`#${productID}Variant`)) {
    if (document.querySelector(`#${productID}Variant`) != null) {
      itemID = document.querySelector(`#${productID}Variant`).value;
    }
  }
  if (
    !!document.querySelector(`#${productID}Qty`) &&
    !!document.querySelector(`#${productID}Select`)
  ) {
    document
      .querySelector(`#${productID}Qty`)
      .setAttribute(
        "value",
        document.querySelector(`#${productID}Select`).value
      );
    document.querySelector(`#${productID}Input`).setAttribute("value", itemID);
    addProductToCart(formID, metafields, itemID);
    document.querySelector(`#${productID}Form`).style.display = "none";
  }
}

function startLoading() {
  document.querySelector(".cartLoader").classList.remove("is-hidden");
}

function stopLoading() {
  document.querySelector(".cartLoader").classList.add("is-hidden");
}

function isNotLoading() {
  return document.querySelector(".cartLoader").classList.contains("is-hidden");
}

function itemTimer(cart) {
  var isSingle = true;
  if (cart.item_count > 1) isSingle = false;
  var second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;
  if (timer || cart.item_count === 0) {
    clearInterval(timer);
  }
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  var countDown = Number(window.localStorage.getItem("timer"));
  if (cart.item_count > 0) {
    timer = setInterval(function () {
      var now = new Date().getTime(),
        distance = countDown - now;

      if (!!document.querySelector(".itemCount")) {
        var itemCount = document.querySelector(".itemCount");
        itemCount.classList.remove("is-hidden");

        if (isSingle) {
          itemCount.innerText =
            ":" +
            " " +
            window.cartItems.cart_count.one.replace(
              "{{ count }}",
              cart.item_count
            );
        } else {
          itemCount.innerText =
            ":" +
            " " +
            window.cartItems.cart_count.other.replace(
              "{{ count }}",
              cart.item_count
            );
        }
        if (distance > 0) {
        } else {
          if (isSingle) {
            itemCount.innerText =
              ":" +
              " " +
              window.cartItems.cart_count.one.replace(
                "{{ count }}",
                cart.item_count
              );
          } else {
            itemCount.innerText =
              ":" +
              " " +
              window.cartItems.cart_count.other.replace(
                "{{ count }}",
                cart.item_count
              );
          }
        }
      }
    }, 1000);
  } else {
    if (!!document.querySelector(".itemCount")) {
      document.querySelector(".itemCount").classList.add("is-hidden");
    }
  }
}

DOMready(function () {
  document.addEventListener("change", (event) => {
    const changedColorRadio = event.target.closest(
      '[data_options="color"] input[type="radio"]'
    );
    if (!changedColorRadio) return; //do nothing

    if (changedColorRadio.value != undefined) {
      if (!!changedColorRadio.closest(".product-form__input")) {
        let productFormInput = changedColorRadio.closest(
          ".product-form__input"
        );
        if (!!productFormInput.querySelector(".form__label span")) {
          productFormInput.querySelector(".form__label span").innerText =
            changedColorRadio.value;
        }
      }
    }
  });

  var selectors = {
    termsCheckbox: ".cart__terms-checkbox",
    requiresTerms: false,
  };

  if (!!document.querySelector(".js-cart-terms-checkboxes")) {
    var termsCheckboxes = document.querySelectorAll(
      ".js-cart-terms-checkboxes"
    );
    var requiresTerms = true;

    termsCheckboxes.forEach(function (termsCheckbox) {
      termsCheckbox.addEventListener("change", function (event) {
        var checkedStatus = event.target.checked;

        termsCheckboxes.forEach(function (termsCheckbox) {
          termsCheckbox.checked = checkedStatus;
        });
      });
    });
  } else {
    var requiresTerms = false;
  }

  document
    .querySelectorAll(
      ".cart-drawer__proceed-to-checkout,button.cart__checkout-button.button"
    )
    .forEach(function (checkoutButton) {
      checkoutButton.addEventListener("click", function (e) {
        if (requiresTerms == true) {
          if (
            document.querySelectorAll(".js-cart-terms-checkboxes")[0].checked
          ) {
            // continue to checkout
          } else {
            alert(window.cartStrings.cartTermsConfirmation);
            e.preventDefault();
            return false;
          }
        }

        e.preventDefault();

        var closestForm = document.querySelectorAll(
          'form[action="' + window.routes.cart_url + '"]'
        )[0];
        var formData = new URLSearchParams(
          new FormData(closestForm)
        ).toString();

        fetch(window.routes.cart_url, {
          method: "POST",
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          // headers: {
          //   Accept: "application/json",
          //   "Content-Type": "application/json",
          // },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            window.location.href = "/checkout";
          })
          .catch(function (error) {
            // Catch errors
            addToCartFail();
          });
      });
    });
});

class VariantProductcardSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantProductcardChange);
  }
  onVariantProductcardChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMediaPrice();
    this.closest(".card-wrapper")
      .querySelector('[name="id"]')
      .setAttribute("value", this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateMediaPrice() {
    this.closest(".card-wrapper").querySelector(
      ".price__regular .price-item--regular"
    ).innerHTML = `From ${Shopify.formatMoney(this.currentVariant.price)}`;
    if (this.currentVariant.featured_image != null) {
      this.closest(".card-wrapper")
        .querySelector(".primery_card_image")
        .setAttribute("src", this.currentVariant.featured_image.src);
    }
  }
}
class VariantProductcard extends VariantProductcardSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) =>
        radio.nextElementSibling.classList.contains("selected")
      ).value;
    });
  }
}

customElements.define("variant-productcard", VariantProductcard);

if (document.querySelector(".accordion-content")) {
  const accordionBtn = document.querySelector(".accordion-btn");
  const accordionContent = document.querySelector(".accordion-content");
  const accordionTextarea = accordionContent?.querySelector("textarea");

  accordionBtn.addEventListener("click", function () {
    accordionBtn.classList.toggle("isOpen");
    toggleAccordionContent();
  });

  accordionBtn.addEventListener("keyup", function (event) {
    if (event.code == "Escape") {
      accordionBtn.classList.remove("isOpen");
      hideAccordionContent();
      event.preventDefault();
    }
  });

  accordionContent.addEventListener("keyup", function (event) {
    if (event.code == "Escape") {
      accordionBtn.classList.remove("isOpen");
      hideAccordionContent();
      event.preventDefault();
    }
  });

  function hideAccordionContent() {
    const accordionBtn = document.querySelector(".accordion-btn");
    const accordionContent = document.querySelector(".accordion-content");
    const accordionTextarea = accordionContent?.querySelector("textarea");
    accordionContent.style.maxHeight = null;
    accordionTextarea.tabIndex = -1;
    accordionBtn.focus();
  }

  function showAccordionContent() {
    const accordionContent = document.querySelector(".accordion-content");
    const accordionTextarea = accordionContent?.querySelector("textarea");
    accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
    accordionTextarea.tabIndex = 0;
    accordionTextarea.focus();
  }

  function toggleAccordionContent() {
    const accordionContent = document.querySelector(".accordion-content");
    if (accordionContent.style.maxHeight) {
      hideAccordionContent();
    } else {
      showAccordionContent();
    }
  }
}

if (document.getElementById("complementary_slider")) {
  var elem = document.getElementById("complementary_slider");
  var flkty = new Flickity(elem, {
    // options
    cellAlign: "center",
    contain: true,
  });
}

if (!!document.querySelector("#CartNote")) {
  document.querySelector("#CartNote").addEventListener(
    "change",
    debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300)
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
